import LobbyMusic from './images/audio/lobby.mp3'
import Auditorium from './images/backdrops/auditorium.jpg'
import AuditoriumM from './images/backdrops/auditoriumP.jpg'
import Entrance from './images/backdrops/entranceD.jpg'
import EntranceM from './images/backdrops/entranceM.jpg'
import EntranceA from './images/backdrops/entranceA.jpg'
import Landing from './images/backdrops/landing.png'
import LandingM from './images/backdrops/landingM.png'
import Exhibition from './images/backdrops/exhibition-hall.jpg'
import Gallerium from './images/backdrops/gallerium.jpg'
import LobbyL from './images/backdrops/lobby.jpg'
import LobbyM from './images/backdrops/lobbyM.jpg'
import LobbyA from './images/backdrops/lobbyA.jpg'
import Logo from './images/backdrops/logo.png'
import MC from './images/backdrops/MC20.png'
import NetworkingL from './images/backdrops/networking.jpg'
import NetworkingM from './images/backdrops/networkingM.jpg'
import LogoL from './images/logo.png'
import routes from './routes'
import Pin from './images/pin.png'
import PinHover from './images/pin-hover.png'
import Agenda from './images/agenda.png'
import AgendaHover from './images/agenda-hover.png'
import Info from './images/info.png'
import InfoHover from './images/info-hover.png'

const dev = {
  apiUrl: 'https://seameo2021.herokuapp.com',
  // apiUrl: 'http://localhost:3000',
}

const prod = {
  apiUrl: 'https://seameo2021.herokuapp.com',
}

const API_KEYS = {
  amplitude: '50ce281293b0885e4f403b8b21e2b6ef',
}

const VOLUME_VALUE = 1

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  logo: {
    landscape: LogoL,
    portrait: Logo,
  },
  countdown: {
    landscape: Entrance,
    portrait: EntranceM,
    ipad: EntranceA,
  },
  entrance: {
    landscape: Landing,
    portrait: LandingM,
  },
  lobby: {
    landscape: LobbyL,
    portrait: LobbyM,
    ipad: LobbyA,
  },
  auditorium1: {
    landscape: Auditorium,
    portrait: AuditoriumM,
  },
  auditorium2: MC,

  exhibition1: Exhibition,
  exhibition2: Exhibition,

  networking: {
    landscape: NetworkingL,
    portrait: NetworkingM,
  },
  gallerium: Gallerium,
  lobbyMusic: LobbyMusic,
}

const layout = {
  auditoriumVid: `
    top: 8%;
    bottom: 36.5%;
    left: 5%;
    right: 36.6%;
  `,
}

const lobbyEntries = [
  {
    id: 'auditorium',
    entryOpenImage: PinHover,
    entryCloseImage: Pin,
    destination: [
      { name: 'Auditorium (LIVE)', url: routes.auditorium1 },
      { name: 'Concurrent Room 1', url: routes.auditorium2 },
      { name: 'Concurrent Room 2', url: routes.auditorium3 },
      { name: 'Concurrent Room 3', url: routes.auditorium4 },
      { name: 'Knowledge Sharing Lounge', url: routes.auditorium5 },
    ],
    css: `
      top: 69.2%;
      left: 45%;
      right: 45%;
      bottom: 40.3%;
    `,
  },
  {
    id: 'exhibition',
    destination: routes.exhibition1,
    entryOpenImage: PinHover,
    entryCloseImage: Pin,
    css: `
      top: 69.2%;
      left: 21%;
      right: 72%;
      bottom: 40.3%;
    `,
  },
  {
    id: 'networking',
    destination: routes.networking,
    entryOpenImage: PinHover,
    entryCloseImage: Pin,
    css: `
      top: 69.2%;
      left: 72.8%;
      right: 20%;
      bottom: 40.3%;
    `,
  },
  {
    id: 'gallerium',
    destination: routes.onDemand,
    entryOpenImage: PinHover,
    entryCloseImage: Pin,
    css: `
      top: 48.5%;
      left: 45%;
      right: 45%;
      bottom: 56.5%;
    `,
  },
  {
    id: 'helpdesk',
    destination: 0,
    entryOpenImage: InfoHover,
    entryCloseImage: Info,
    css: `
      top: 86.5%;
      left: 39.5%;
      bottom: 19.5%;  
    `,
  },
  {
    id: 'programme',
    destination: 1,
    entryOpenImage: AgendaHover,
    entryCloseImage: Agenda,
    css: `
      top: 90.5%;
      left: 18.5%;
      bottom: 10%;
    `,
  },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  VOLUME_VALUE,
  eventName: 'International Conference on Special Education (ICSE 2021)',
  ...config,
}
